export enum Roles {
    SYSTEM_ADMIN = 'SYSTEM_ADMIN',
    WRITE = 'WRITE',
    READ = 'READ',
    KEY_USER = 'KEY_USER',
    SUPPLIER = 'SUPPLIER',
    BBA = 'BBA',
    CREATE_USER = 'CREATE_USER'
}
